import { Box, Container, HStack } from '@chakra-ui/react'
import { Link as NavLink } from 'react-router-dom'

import AgenciesControl from '../agencies/AgenciesDropdown'
import MFLogo from '../logo'
import MFEnvBadge from '../MFEnvBadge'

import { useMFNav } from './MFNav.Provider'
import MFNavToggleButton from './MFNav.ToggleButton'

/**
 * MFNavHeader component to render the navbar docked at top of the page.
 *
 * @returns {JSX.Element} The rendered navigation top bar component.
 */
export default function MFNavHeader() {
  const {
    menu: { size },
    isOpen,
    onOpen,
    onClose
  } = useMFNav()

  return (
    <Box as="header" position="fixed" top="0" left="0" w="100%" h="44px" zIndex="modal">
      <Box borderBottomWidth="1px" borderColor="neutral.50" bg="surface" position="relative">
        <Container py="1.5" px="3" maxW="full">
          {/* OUTER CONTAINER: Ensures proper spacing */}
          <HStack h="8" justify="space-between">
            {/* LEFT SECTION (Drawer Mode) */}
            {size.value === 'drawer' && (
              <HStack justify="start" spacing="8" zIndex="tooltip">
                <MFNavToggleButton onOpen={onOpen} isOpen={isOpen} onClose={onClose} />
                <HStack as={NavLink} to="/dashboard" position="relative" alignItems="end">
                  <MFLogo size={125} />
                  <MFEnvBadge
                    fontSize="3xs"
                    position="absolute"
                    bottom="-2"
                    right="0"
                    expanded={size.value !== 'dock'}
                  />
                </HStack>
              </HStack>
            )}

            {/* CENTER SECTION: Breadcrumbs (Ensures Centering) */}
            {/* <Flex
              flex="1"
              justify="center"
              ml={size.value === 'full' || state.isHovered ? 56 : size.value === 'dock' ? 16 : 0}
              transition="all .3s ease"
            >
              <HStack alignItems="center">
                {(breadCrumbs ?? []).map(crumb => (
                  <HStack key={crumb.id}>
                    {crumb?.icon}
                    {crumb.navLink && crumb.navLink !== '/' ? (
                      <Link as={NavLink} to={crumb.navLink} size="xs" color="fg !important" fontWeight="semibold">
                        {crumb?.title}
                      </Link>
                    ) : (
                      <Text size="xs" mb={0}>
                        {crumb?.title}
                      </Text>
                    )}
                  </HStack>
                ))}
              </HStack>
            </Flex> */}

            {/* RIGHT SECTION: Always at the end */}
            <HStack ml="auto" justify="end" spacing="8" zIndex="tooltip">
              <AgenciesControl>
                <AgenciesControl.Dropdown badge logout />
              </AgenciesControl>
            </HStack>
          </HStack>
        </Container>
      </Box>
    </Box>
  )
}
